import React from 'react';

const NewsContext = React.createContext();

export default NewsContext;
